module.exports = __webpack_public_path__ + "static/Portal-d6ebc5f15d660b07bae9d5ef20d6cae2.png";